import React from 'react';
import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined';
import {
  PreviewGrid, PreviewHeader, PreviewLines, PreviewPage, PreviewPanel, PreviewTable,
} from '../../../../components/access-denied/preview/PreviewParts';

/** Prévia falsa do atendimento para a tela de bloqueio (dados de exemplo fixos). */
const AppointmentLockedPreview = () => (
  <PreviewPage>
    <PreviewHeader icon={<MedicalServicesOutlinedIcon />} title="Atendimento" subtitle="Hoje, 10:00 · Sessão de exemplo" />
    <PreviewGrid>
      <PreviewPanel title="Queixa principal">
        <PreviewLines widths={[90, 72, 84]} />
      </PreviewPanel>
      <PreviewPanel title="Evolução">
        <PreviewLines widths={[86, 94, 66, 78]} />
      </PreviewPanel>
    </PreviewGrid>
    <PreviewPanel title="Histórico">
      <PreviewTable
        columns={['Data', 'Tipo', 'Registro']}
        rows={[
          ['01/01', 'Sessão', 'Registro de exemplo'],
          ['08/01', 'Sessão', 'Registro de exemplo'],
          ['15/01', 'Retorno', 'Registro de exemplo'],
        ]}
      />
    </PreviewPanel>
  </PreviewPage>
);

export default AppointmentLockedPreview;
